import React from 'react';
import Menu from '../components/Menu';
import '../CSS/LayoutDashboard.css';

const LayoutDashboard = ({ children }) => {
  return (
    <div className="nova-dashboard-shell">
      <Menu />

      <main className="nova-dashboard-main">
        {children}
      </main>
    </div>
  );
};

export default LayoutDashboard;
